// =============================================================================
// NAD+ Benefits Grid Section Component
// =============================================================================

export class NADBenefitsGrid {
  private element: HTMLElement;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupScrollAnimation();
  }

  /**
   * Fade in each benefit card as it becomes visible; stagger delays come
   * from the nth-child rules in the section SCSS
   */
  private setupScrollAnimation(): void {
    const items = this.element.querySelectorAll<HTMLElement>('.nad-benefits-grid__item');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            this.observer?.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    items.forEach((item) => this.observer?.observe(item));
  }

  public destroy(): void {
    this.observer?.disconnect();
    this.observer = null;
    this.element.querySelectorAll('.nad-benefits-grid__item.animate-in')
      .forEach(el => el.classList.remove('animate-in'));
  }

  static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-benefits-grid')
      .forEach(el => {
        if (!(el as any)._nadComponentInstance) {
          (el as any)._nadComponentInstance = new NADBenefitsGrid(el);
        }
      });
  }
}
